import { z } from 'zod';
import { SanityDocumentLikeSchema, SanityReferenceSchema } from '../sanity';

export const GridItemPlacementSchema = z.object({
  columnSpan: z.number(),
  columnStart: z.number(),
  rowSpan: z.number(),
  rowStart: z.number()
});

export const GridItemComponentSchema = z
  .union([SanityReferenceSchema, SanityDocumentLikeSchema])
  .optional()
  .nullable();

const GridItemComponentTypeSchema = z
  .union([
    z.literal('dynamic'),
    z.literal('divider'),
    z.literal('portableText'),
    z.literal('modalText')
  ])
  .optional()
  .nullable();

export const GridItemSchema = z.object({
  componentType: GridItemComponentTypeSchema,
  component: GridItemComponentSchema,
  mobile: GridItemPlacementSchema.optional().nullable(),
  desktop: GridItemPlacementSchema.optional().nullable(),
  placements: z
    .array(GridItemPlacementSchema.extend({ grid: z.string() }))
    .optional()
    .nullable(),
  id: z.string()
});

export const GridLayoutSchema = z.object({
  autoSortMobile: z.boolean().nullable().optional(),
  gridItems: z.array(GridItemSchema).nullable().optional()
});

export type GridItem = z.infer<typeof GridItemSchema>;
export type GridLayout = z.infer<typeof GridLayoutSchema>;
export type GridItemPlacement = z.infer<typeof GridItemPlacementSchema>;
export type GridItemComponent = z.infer<typeof GridItemComponentSchema>;
export type GridItemComponentType = z.infer<typeof GridItemComponentTypeSchema>;
